import React, { useCallback, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { CardView, rem, SettingsItemNavigate } from 'design-system';
import { formatPlural } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import BankLoginsHelp from './BankLoginsHelp';
import { isWeb } from '../../../../constants';
const AccountOverviewFooter = ({ title, hiddenCount, closedCount, }) => {
    const navigation = useMainStackNavigation();
    const onPressHidden = useCallback(() => {
        navigation.navigate('HiddenAccountsOverview', {
            title: title,
        });
    }, [navigation, title]);
    const onPressClosed = useCallback(() => {
        navigation.navigate('ClosedAccountsOverview', {
            title: title,
        });
    }, [navigation, title]);
    const content = useMemo(() => {
        switch (title) {
            case 'Investments': {
                return <BankLoginsHelp />;
            }
            case 'Savings': {
                return <BankLoginsHelp />;
            }
            case 'Everyday': {
                return <BankLoginsHelp />;
            }
            default:
                return null;
        }
    }, [title]);
    const showHiddenButton = hiddenCount > 0;
    const showClosedButton = closedCount > 0;
    if (!content && !showHiddenButton && !showClosedButton)
        return null;
    return (<>
      {showHiddenButton ? (<CardView noMarginTop>
          <SettingsItemNavigate onPress={onPressHidden} style={styles.webPadding} title={`${hiddenCount} ${formatPlural('hidden account', 'hidden accounts', hiddenCount)}`}/>
        </CardView>) : null}
      {showClosedButton ? (<CardView noMarginTop>
          <SettingsItemNavigate onPress={onPressClosed} style={styles.webPadding} title={`${closedCount} ${formatPlural('closed account', 'closed accounts', closedCount)}`}/>
        </CardView>) : null}
      {content}
    </>);
};
const styles = StyleSheet.create({
    webPadding: {
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
});
export default AccountOverviewFooter;
